import InviraUserCreate from './InviraUserCreate.vue'
export {InviraUserCreate}
export default InviraUserCreate

